export default "__VITE_ASSET__rlrZ01qd__"